import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"

import {
  MutationAssignCreditArgs,
  MutationRewardEmployeesArgs,
  QueryGetTransferOutcomeArgs,
  QueryFlexiPointsExpiryListArgs
} from "@irati/types/ops"
import {FlexiPointTransfer} from "@irati/types"
import assignCreditMutation, {assignCreditKey} from "./mutations/assignCredit"
import rewardEmployeesMutation, {rewardEmployeesKey} from "./mutations/rewardEmployees"
import getTransferOutcome, {getTransferOutcomeKey} from "./queries/getTransferOutcome"
import flexiPointsExpiryList, {flexiPointsExpiryListKey} from "./queries/flexiPointsExpiryList"

class FlexiPoints extends PBService {
  async assignCredit(variables: MutationAssignCreditArgs, options: QueryOptions = {}) {
    return client.mutate({...options, mutation: assignCreditMutation, variables}).then(({data}) => {
      return data[assignCreditKey]
    })
  }

  async rewardEmployees(variables: MutationRewardEmployeesArgs, options: QueryOptions = {}) {
    return client.mutate({...options, mutation: rewardEmployeesMutation, variables}).then(({data}) => {
      return data[rewardEmployeesKey]
    })
  }

  getTransferOutcome(transferId: string, options: QueryOptions = {}): Promise<FlexiPointTransfer> {
    const variables: QueryGetTransferOutcomeArgs = {transferId}
    return client.query({...options, query: getTransferOutcome, variables}).then(({data}) => data[getTransferOutcomeKey])
  }

  flexiPointsExpiryList(variables: QueryFlexiPointsExpiryListArgs, options: QueryOptions = {}) {
    return client.query({...options, query: flexiPointsExpiryList, variables}).then(({data}) => data[flexiPointsExpiryListKey])
  }
}

const flexiPointService = new FlexiPoints({errorHandlers: []})

export default flexiPointService
